module.exports = __webpack_public_path__ + "a36476511d7139cdfc7350cce577d908.svg";